import { render } from "./TheSearchImageOnTopPage.vue?vue&type=template&id=2bcf2fc0&scoped=true&ts=true"
import script from "./TheSearchImageOnTopPage.vue?vue&type=script&lang=ts"
export * from "./TheSearchImageOnTopPage.vue?vue&type=script&lang=ts"

import "./TheSearchImageOnTopPage.vue?vue&type=style&index=0&id=2bcf2fc0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcf2fc0"]])

export default __exports__